export default __webpack_public_path__ + "static/media/11-34.3a28d5fb.png";